import { z } from 'zod';

/**
 * Query parameters for vendor payout history endpoint
 * GET /vendor/payouts
 */
export const VendorPayoutHistoryQuerySchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  limit: z.coerce.number().int().min(1).max(100).default(20),
  status: z
    .enum([
      'PENDING',
      'PROCESSING',
      'COMPLETED',
      'FAILED',
      'CANCELLED',
      'RETRY_PENDING',
      'EXHAUSTED',
      'HELD',
    ])
    .optional(),
  dateFrom: z.coerce.date().optional(),
  dateTo: z.coerce.date().optional(),
  venueId: z.string().uuid().optional(),
});

export type VendorPayoutHistoryQuery = z.infer<typeof VendorPayoutHistoryQuerySchema>;

/**
 * Path parameters for vendor payout detail endpoint
 * GET /vendor/payouts/:payoutId
 */
export const VendorPayoutDetailParamsSchema = z.object({
  payoutId: z.string().uuid(),
});

export type VendorPayoutDetailParams = z.infer<typeof VendorPayoutDetailParamsSchema>;

/**
 * Query parameters for vendor earnings forecast endpoint
 * GET /vendor/payouts/forecast
 */
export const VendorEarningsForecastQuerySchema = z.object({
  period: z.enum(['tomorrow', 'week', 'month']).default('tomorrow'),
  venueId: z.string().uuid().optional(),
});

export type VendorEarningsForecastQuery = z.infer<typeof VendorEarningsForecastQuerySchema>;
